export const createWizzard = (raw, config) => {
  const showSteps = []

  for (const name of raw) {
    for (const obj of config) {
      if (obj.beName === name) {
        showSteps.push(obj)
      }
    }
  }

  return showSteps.map((obj, idx) => ({ ...obj, stepId: idx + 1 }))
}

export const projectCookieData = (data) => {
  return encodeURIComponent(
    JSON.stringify({
      id: data.id,
      title: data.title,
      siteCity: data.siteCity,
      hoursPerWeek: data.hoursPerWeek
    })
  )
}

export const passwordCheck = (ctx) => {
  return [
    {
      regex: /\W/,
      message: ctx.$t('talent.register.error.characters.new'),
      extendVal: 'valChars'
    },
    {
      regex: /(?=.*[A-Z])/,
      message: ctx.$t('talent.register.error.capitals.new'),
      extendVal: 'valCapitals'
    },
    {
      regex: /(?=.*[a-z])/,
      message: ctx.$t('talent.register.error.lowers.new'),
      extendVal: 'valLowers'
    },
    {
      regex: /(?=.*[0-9])/,
      message: ctx.$t('talent.register.error.digits.new'),
      extendVal: 'valDigits'
    },
    {
      regex: /^.{10,}$/,
      message: ctx.$t('talent.register.error.length.new'),
      extendVal: 'valLength'
    }
  ]
}

export const passwordProgress = (ctx, pass) => {
  let strengthScore = 0
  let prog = passwordCheck(ctx).reduce((memo, { regex }) => memo + regex.test(pass), 0)

  if (prog > 2 && pass.length > 9) {
    prog++
  }

  switch (prog) {
    case 0:
    case 1:
      strengthScore = 0
      break
    case 2:
      strengthScore = 25
      break
    case 3:
      strengthScore = 50
      break
    case 4:
      strengthScore = 75
      break
    case 5:
      strengthScore = 100
      break
  }

  return {
    score: strengthScore,
    color: ['error', 'warning', 'success'][Math.floor(strengthScore / 40)]
  }
}
